import gql from 'graphql-tag';

const query = gql`
  query GoalSettings {
    me {
      id
      systemOfMeasures
      systemOfMeasuresNutrition
      lastMeasurement: measurement {
        weight(request: { limit: 1 }) {
          value
          unit
        }
      }
      goalWeight {
        value
        unit
      }
      diet {
        id
        mode
        activityLevel
        spontaneousActivityLevel
        preferredMacronutrientRatio {
          protein
          fat
          carbohydrate
        }
      }
    }
  }
`;

export default query;
